import Header from 'app/containers/widget/launcher/conversationsList/header'
import { useSelector } from 'react-redux'
import MessageItem from 'app/components/MessageItem'

const getDepartments = ({ widgetData }) => widgetData.widgetInfo.data.teams

function Departments() {
  const departments = useSelector(getDepartments)

  return (
    <div className="messenger_tab">
      <Header />
      <ul className="conversations_list_messages_container">
        {departments.length > 0 &&
          departments.map((department) => <MessageItem key={department._id} department={department} />)}
      </ul>
    </div>
  )
}

export default Departments
